import React, { CSSProperties, useState } from "react";

import classNames from "classnames";

import { Placement } from "./types";

import styles from "./Tooltip.module.scss";

interface TooltipProps {
  content: string | React.ReactNode;
  children: React.ReactNode;
  placement?: Placement;
  isOpen?: boolean;
  style?: CSSProperties;
  className?: string;
  onHover?(): void;
}

const Tooltip = ({
  content,
  children,
  placement = "bottom",
  isOpen,
  style,
  className,
  onHover,
}: TooltipProps) => {
  const [_isOpen, _setIsOpen] = useState(isOpen ?? false);

  const toggleIsOpen = () => !isOpen && _setIsOpen(!_isOpen);

  const handleHover = () => {
    onHover && onHover();
    toggleIsOpen();
  };

  return (
    <div
      onPointerEnter={handleHover}
      onPointerLeave={toggleIsOpen}
      className={classNames(styles.container, className)}
      style={style}
    >
      {_isOpen && (
        <div
          onMouseOver={() => _setIsOpen(true)}
          role="tooltip"
          className={classNames(
            styles.tooltip,
            placement && styles[`tooltip--${placement}`],
          )}
        >
          {content ?? null}
        </div>
      )}
      {children}
    </div>
  );
};

export default Tooltip;
